import { render, staticRenderFns } from "./DocumentFollowupTable.vue?vue&type=template&id=1732277e&scoped=true"
import script from "./DocumentFollowupTable.vue?vue&type=script&lang=js"
export * from "./DocumentFollowupTable.vue?vue&type=script&lang=js"
import style0 from "./DocumentFollowupTable.vue?vue&type=style&index=0&id=1732277e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1732277e",
  null
  
)

export default component.exports